<app-tabla
  [datos]="datos"
  [columnas]="columnas"
  [totalCount]="totalCount"
  [(query)]="query"
  (queryChange)="listar()"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay solicitudes finalizadas' }"
  [firstLastButtons]="false"
  [goto]="false"
></app-tabla>
